import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

import {h} from "vue";
import {IconFont} from "@/lib/util";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModuleItemView',
  props: {
    name: {},
    title: {},
    description: {},
    must: { type: Boolean },
    checked: { type: Boolean }
  },
  emits: ['on-checked'],
  setup(__props: any, { emit: __emit }) {


const props = __props
const emit = __emit

const onclick = () => {
  if (props.must) return
  emit('on-checked', props.name, !props.checked)
}

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createBlock(_component_a_flex, _mergeProps({
    vertical: "",
    class: ["module-list-item", {active:_ctx.checked}]
  }, _ctx.$attrs, _toHandlers(_ctx.$attrs)), {
    default: _withCtx(() => [
      _createVNode(_component_a_flex, {
        justify: "space-between",
        align: "center",
        gap: "small",
        class: "module-list-item-header"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_avatar, {
            icon: h(_unref(IconFont),{type:'icon-module'})
          }, null, 8, ["icon"]),
          _createVNode(_component_a_typography_text, {
            style: {"flex":"1 1 auto"},
            content: _ctx.title
          }, null, 8, ["content"]),
          (_ctx.must)
            ? (_openBlock(), _createBlock(_component_a_typography_text, { key: 0 }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("必选")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_a_typography_paragraph, {
          ellipsis: {rows:2},
          content: _ctx.description
        }, null, 8, ["content"])
      ]),
      _createVNode(_component_a_flex, {
        justify: "space-between",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_typography_text, { type: "secondary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.checked ? '已启用' : '未启用'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_switch, {
            disabled: _ctx.must,
            checked: _ctx.checked,
            onChange: onclick
          }, null, 8, ["disabled", "checked"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})